export enum EAnalyticsEvent {
  PageVisited = 'Page Visited',
  WalletConnected = 'Wallet Connected',
  AllowanceSet = 'Allowance Set',
  ConfigSet = 'Config Set',
}
